import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Form, CardHeader, CardBody, Button } from 'reactstrap';
import PluginFieldset from './fieldsets/PluginFieldset';
import RemoveButton from './../RemoveButton';

class PluginForm extends Component {
  static propTypes = {
    categories: PropTypes.array.isRequired,
    formErrors: PropTypes.object,
    isLoading: PropTypes.bool,
    config: PropTypes.object,
    onVenueSelect: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    currentUser: ImmutablePropTypes.map,
    pricingTiers: ImmutablePropTypes.map.isRequired,
  }

  render() {
    const {
      formErrors, isLoading, categories, config, pricingTiers, onClose,
      onSubmit, onVenueSelect, currentUser
    } = this.props;

    return (
      <Form>
        <fieldset disabled={isLoading}>
          <CardHeader>
            <h4>Promote Your Event Now</h4>
            <RemoveButton className='close' onClick={onClose}/>
          </CardHeader>
          <CardBody>
            <PluginFieldset
              formErrors={formErrors}
              config={config}
              categories={categories}
              currentUser={currentUser}
              pricingTiers={pricingTiers}
              onVenueSelect={onVenueSelect}
            />
            <Button className='btn btn-primary submit' onClick={onSubmit} disabled={formErrors.size > 0}>Submit</Button>
          </CardBody>
        </fieldset>
      </Form>
    );
  }
}

export default reduxForm({
  form: 'eventSubmission',
  destroyOnUnmount: false,
})(PluginForm);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/PluginForm.jsx